import { Color } from './theme-interfaces';

//this object contains all colors that can be used in this project
const COLORS: Color = {
  BlackMain: '#000000',
  BlackLight: '#333333',

  GrayExtraLight: '#b7b7b7',
  GrayMain: '#6A6A6A',
  GrayExtraDark: '#2B2B2B',
  GrayDark: '#777777',

  LightGrayMain: '#BABABA',
  LightGrayDark: '#A8A8A8',
  LightGrayLight: '#a0a0a0',
  LightGraySecondShade: '#dadada',

  WhiteMain: '#FFFFFF',
  WhiteDark: '#F3F3F3',
  WhiteLight: '#F6F6F6',

  RedMain: '#D90615',
  RedDark: 'calc(#DC1D27 - #FF3E49)',
  RedLight: '#FF3E49',
  RedExtraDark: '#d9534f',

  YellowMain: '#FFC400',
  YellowDark: 'calc(#FF8900 - #FFC400)',
  YellowLight: '#FF8900',

  GreenMain: '#47A01A',
  GreenDark: 'calc(#47A01A - #54BF1D)',
  GreenLight: '#54BF1D',
  GreenShade: 'rgba(188, 248, 164, 0.2)',

  BlueMain: '#1C6DAF',
  BlueDark: 'calc(#1C6DAF - #2791E8)',
  BlueLight: '#2791E8',

  DarkBlue: '#0B3B60',
  LightBlue: '#125b8a',
  LightBorderBlue: '#125b8a',
  DarkerBlue: '#083a55',
  DarkerBorderBlue: '#083a55',
  LightRed: '#F0A2A2',
  LightBorderRed: '#F5C1C1',
  DarkerRed: '#9B0018',
  DarkerBorderRed: '#7D0014',

  LightOpacityBlack: 'rgba(0, 0, 0, .15)',
};

export default COLORS;
